import type { EventOutcome } from "@/context/pending-workflows/PendingWorkflowsContext";

/** La confirmación del apply al catálogo del proveedor, no la de cada comprador. */
export function resultadoDelAumentoAplicado(
  payload: Record<string, unknown>
): EventOutcome {
  const aplicadas = Number(payload.successCount ?? 0);
  const fallidas = Number(payload.failedCount ?? 0);
  if (payload.status === "completed") {
    return {
      isTerminal: true,
      toast: {
        variant: "success",
        title: "Precios publicados actualizados",
        description: `Se aplicaron ${aplicadas} ${
          aplicadas === 1 ? "variante" : "variantes"
        } en tu catálogo.`,
      },
    };
  }
  if (payload.status === "partial" || payload.status === "failed") {
    return {
      isTerminal: true,
      toast: {
        variant: payload.status === "failed" ? "error" : "warning",
        title: "Revisá la actualización de precios",
        description: `${aplicadas} ${
          aplicadas === 1 ? "variante aplicada" : "variantes aplicadas"
        }; ${fallidas} ${fallidas === 1 ? "falló" : "fallaron"}.`,
      },
    };
  }
  return { isTerminal: false };
}
